import _ from 'lodash'
import {migrateColorsFactory} from './migrateColors'
import migrateFonts from './migrateFonts'
import migrateBorder from './migrateBorder'
import migratePadding from './migratePadding'
import migrateBorderRadiusFactory from './migrateBorderRadius'
import migrateIconRotation from './migrateIconRotation'
import type {ParsedStyleItem} from '../types'
import migrateBackground from './migrateBackground'

export interface MigratePropertiesProps {
    useCssColor: boolean
    withBorderRadiusAsOneParam: boolean
}

const migrateProperties = (
    props: MigratePropertiesProps = {useCssColor: false, withBorderRadiusAsOneParam: false}
): ((items: ParsedStyleItem[]) => ParsedStyleItem[]) => {
    const {useCssColor, withBorderRadiusAsOneParam} = props
    return _.flow([
        migrateColorsFactory(useCssColor),
        migrateFonts,
        migrateBorder,
        migrateBackground,
        migratePadding,
        migrateBorderRadiusFactory(withBorderRadiusAsOneParam),
        migrateIconRotation
    ])
}

export default migrateProperties
